import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { buildFlowBandejaAnalytics } from '../../../app/helpers/flowBandejaAnalyticsHelper';
import FlowCasePhaseBadge from './FlowCasePhaseBadge';

const FlowHistoryAnalytics = ({ events = [], roles = [], states = [] }) => {
  const { t } = useTranslation();
  const analytics = buildFlowBandejaAnalytics({ events, roles, states, t });

  if (!analytics.rows.length && !analytics.nodes.length) {
    return null;
  }

  return (
    <div className="flow-history-analytics">
      <section className="flow-history-analytics__section">
        <h6 className="text-uppercase text-muted small mb-3">
          {t('general.flow-engine.history.times-title', 'Tiempo en bandejas')}
        </h6>
        <div className="table-responsive">
          <table className="table table-sm table-bordered mb-2 bg-white">
            <thead>
              <tr>
                <th>{t('general.flow-engine.history.times-bandeja', 'Bandeja')}</th>
                <th>{t('general.flow-engine.history.times-duration', 'Tiempo')}</th>
              </tr>
            </thead>
            <tbody>
              {analytics.rows.map((row) => (
                <tr key={row.id}>
                  <td>
                    <strong>{row.roleLabel}</strong>
                    {row.isReturn && (
                      <span className="flow-history-times__return">
                        {' '}
                        {t('general.flow-engine.history.times-return', '(devolución)')}
                      </span>
                    )}
                  </td>
                  <td>{row.formatted}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="small">
          <strong>
            {analytics.isClosed
              ? t('general.flow-engine.history.times-total-closed', 'Tiempo total del proceso:')
              : t('general.flow-engine.history.times-total-open', 'Tiempo acumulado hasta ahora:')}
          </strong>
          {' '}
          {analytics.formattedTotal}
        </div>
      </section>

      <section className="flow-history-analytics__section">
        <h6 className="text-uppercase text-muted small mb-3">
          {t('general.flow-engine.history.diagram-title', 'Recorrido del registro')}
        </h6>
        <div className="flow-history-diagram" aria-label={t('general.flow-engine.history.diagram-title', 'Recorrido del registro')}>
          {analytics.nodes.map((node, index) => (
            <div key={node.id} className="flow-history-diagram__step">
              {index > 0 && (
                <div className="flow-history-diagram__arrow" aria-hidden="true">↓</div>
              )}
              <div className={`flow-history-diagram__row${node.isReturn ? ' is-return' : ''}`}>
                <div className={`flow-history-diagram__node${node.isReturn ? ' is-return' : ''}${node.isTerminal ? ' is-terminal' : ''}${node.casePhase ? ` is-phase-${node.casePhase}` : ''}`}>
                  <div className="flow-history-diagram__label">{node.label}</div>
                  {(node.phaseLabel || node.casePhase) && (
                    <div className="flow-history-diagram__phase">
                      <FlowCasePhaseBadge phase={node.casePhase} label={node.phaseLabel} />
                    </div>
                  )}
                  {node.action && !node.isTerminal && !node.isReturn && (
                    <div className="flow-history-diagram__action">{node.action}</div>
                  )}
                </div>
                {node.motivo && (
                  <div className="flow-history-diagram__motivo">
                    <strong>{t('flow.motivo.label', 'Motivo')}:</strong> {node.motivo}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

FlowHistoryAnalytics.propTypes = {
  events: PropTypes.array,
  roles: PropTypes.array,
  states: PropTypes.array
};

export default FlowHistoryAnalytics;
